import Route from 'mewe/routes/route';
import { inject as service } from '@ember/service';

export default class AuthGoogleCallbackRoute extends Route {
  @service router;

  queryParams = {
    id_token: {
      refreshModel: false,
    },
    code: {
      refreshModel: false,
    },
    error: {
      refreshModel: false,
    },
    state: {
      refreshModel: false,
    },
  };

  model(params, transition) {
    const { to: toRouteInfo } = transition;
    const queryParams = toRouteInfo.queryParams;

    // For hybrid flow, parameters come in URL fragment, not query params
    // We need to read them from the URL fragment
    const fragmentParams = this.parseFragmentParams();

    // Parse state parameter if it exists
    let stateData = {};
    const stateParam = fragmentParams.state || queryParams.state;
    if (stateParam) {
      try {
        stateData = JSON.parse(atob(stateParam));
      } catch (error) {
        console.error('Failed to parse state parameter:', error);
      }
    }

    // we need to handle both URL query parameters and fragment parameters,
    // because OAuth2 responses can use either method depending on the flow.
    return {
      id_token: fragmentParams.id_token || queryParams.id_token,
      code: fragmentParams.code || queryParams.code,
      error: fragmentParams.error || queryParams.error,
      state: stateParam,
      stateData: stateData,
    };
  }

  parseFragmentParams() {
    const fragment = window.location.hash.substring(1); // Remove the # character
    const params = {};

    if (fragment) {
      const pairs = fragment.split('&');
      pairs.forEach(pair => {
        const [key, value] = pair.split('=');
        if (key && value) {
          params[decodeURIComponent(key)] = decodeURIComponent(value);
        }
      });
    }

    return params;
  }

  afterModel(model) {
    // Handle OAuth errors
    if (model.error) {
      console.error('Google OAuth error:', model.error);
      this.closePopup();
      return;
    }

    // Handle missing ID token and code
    if (!model.id_token && !model.code) {
      console.error('No ID token or authorization code received from Google');
      this.closePopup();
      return;
    }

    this.processGoogleAuth(model);
  }

  closePopup() {
    if (window.opener && !window.opener.closed) {
      window.close();
    }
  }

  async processGoogleAuth(authResponse) {
    try {
      window.opener.postMessage({
        key: 'authComplete',
        authResponse: JSON.stringify(authResponse),
      }, '*');

      this.closePopup();

    } catch (error) {
      console.error('Google SIGN-IN - callback error', error);
      this.closePopup();
    }
  }
}